export const languagesWithDialects = [
    {
      language: 'Arabic',
      lang_code: 'ar',
      dialects: [
        {
          dialect: 'Modern Standard Arabic',
          dialect_code: 'ar-SA',
        },
        {
          dialect: 'Egyptian Arabic',
          dialect_code: 'ar-EG',
        },
        {
          dialect: 'Gulf Arabic',
          dialect_code: 'ar-GH',
        },
        {
          dialect: 'Levantine Arabic',
          dialect_code: 'ar-LB',
        },
        {
          dialect: 'Maghrebi Arabic',
          dialect_code: 'ar-MA',
        },
      ],
    },
    {
      language: 'English',
      lang_code: 'en',
      dialects: [
        {
          dialect: 'American English',
          dialect_code: 'en-US',
        },
        {
          dialect: 'British English',
          dialect_code: 'en-GB',
        },
        {
          dialect: 'Australian English',
          dialect_code: 'en-AU',
        },
      ],
    },
    {
      language: 'French',
      lang_code: 'fr',
      dialects: [
        {
          dialect: 'European French',
          dialect_code: 'fr-FR',
        },
        {
          dialect: 'Canadian French',
          dialect_code: 'fr-CA',
        },
        {
          dialect: 'African French',
          dialect_code: 'fr-AF',
        },
      ],
    },
    {
      language: 'Mandarin Chinese',
      lang_code: 'zh',
      dialects: [
        {
          dialect: 'Simplified Mandarin',
          dialect_code: 'zh-CN',
        },
        {
          dialect: 'Traditional Mandarin',
          dialect_code: 'zh-TW',
        },
        {
          dialect: 'Cantonese',
          dialect_code: 'zh-HK',
        },
      ],
    },
    {
      language: 'Spanish',
      lang_code: 'es',
      dialects: [
        {
          dialect: 'Castilian Spanish',
          dialect_code: 'es-ES',
        },
        {
          dialect: 'Mexican Spanish',
          dialect_code: 'es-MX',
        },
        {
          dialect: 'Argentinian Spanish',
          dialect_code: 'es-AR',
        },
      ],
    },
    {
      language: 'Hindi',
      lang_code: 'hi',
      dialects: [
        {
          dialect: 'Standard Hindi',
          dialect_code: 'hi-IN',
        },
        {
          dialect: 'Bhojpuri',
          dialect_code: 'bh',
        },
        {
          dialect: 'Rajasthani',
          dialect_code: 'raj',
        },
      ],
    },
    {
      language: 'Russian',
      lang_code: 'ru',
      dialects: [
        {
          dialect: 'Standard Russian',
          dialect_code: 'ru-RU',
        },
        {
          dialect: 'Siberian Russian',
          dialect_code: 'ru-SI',
        },
      ],
    },
    {
      language: 'Portuguese',
      lang_code: 'pt',
      dialects: [
        {
          dialect: 'European Portuguese',
          dialect_code: 'pt-PT',
        },
        {
          dialect: 'Brazilian Portuguese',
          dialect_code: 'pt-BR',
        },
      ],
    },
    {
      language: 'Bengali',
      lang_code: 'bn',
      dialects: [
        {
          dialect: 'Standard Bengali',
          dialect_code: 'bn-BD',
        },
        {
          dialect: 'Eastern Bengali',
          dialect_code: 'bn-IN',
        },
      ],
    },
    {
      language: 'Japanese',
      lang_code: 'ja',
      dialects: [
        {
          dialect: 'Standard Japanese',
          dialect_code: 'ja-JP',
        },
        {
          dialect: 'Kansai Japanese',
          dialect_code: 'ja-KS',
        },
      ],
    },
    {
      language: 'Korean',
      lang_code: 'ko',
      dialects: [
        {
          dialect: 'Standard Korean',
          dialect_code: 'ko-KR',
        },
        {
          dialect: 'North Korean',
          dialect_code: 'ko-KP',
        },
      ],
    },
    {
      language: 'German',
      lang_code: 'de',
      dialects: [
        {
          dialect: 'Standard German',
          dialect_code: 'de-DE',
        },
        {
          dialect: 'Swiss German',
          dialect_code: 'de-CH',
        },
        {
          dialect: 'Austrian German',
          dialect_code: 'de-AT',
        },
      ],
    },
    {
      language: 'Turkish',
      lang_code: 'tr',
      dialects: [
        {
          dialect: 'Standard Turkish',
          dialect_code: 'tr-TR',
        },
      ],
    },
    {
      language: 'Vietnamese',
      lang_code: 'vi',
      dialects: [
        {
          dialect: 'Northern Vietnamese',
          dialect_code: 'vi-VN',
        },
        {
          dialect: 'Southern Vietnamese',
          dialect_code: 'vi-SG',
        },
      ],
    },
  ];
  export const languages =  languagesWithDialects.map(({language, lang_code}) => ({text: language, value: lang_code}))

  export default languagesWithDialects;
  